"use client";
import AIAgentFooter from "@/components/AIAgentFooter";
import AIAgentsSectionAds from "@/components/AIAgentsSectionAds";
import BookDemoSection from "@/components/BookDemoSection";
import CtaBanner from "@/components/CtaBanner";
import  
HeroMainSection from "@/components/HeroMainSection";
import HiringWallSection from "@/components/HiringWallSection";
import ObjectionsSection from "@/components/ObjectionsSection";
import RecruitmentTeam from "@/components/RecruitmentTeam";
import TimeBreakdownSection from "@/components/TimeBreakdownSection";
import ScrollReveal from "@/components/ScrollReveal";
import React from "react";
import Head from "next/head";
import "@/i18n";
import AdsPageNavbar from "@/components/AdsPageNavbar";
import AdsFooter from "@/components/AdsFooter";
import HowItWorks from "@/components/HowItWorks";
import NumbersStats from "@/components/NumbersStats";
const page = () => {
  return (
    <div>
      <Head>
        <title>
          Recruitment Automation Software That Multiplies Your Hiring Team |
          Getgeek
        </title>
        <meta
          name="description"
          content="Getgeek's recruitment automation software gives your recruiters 6 AI agents - so a 2-person team does the work of 20. Book a free demo. No credit card required."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:site_name"
          content="Getgeek's recruitment automation software gives your recruiters 6 AI agents - so a 2-person team does the work of 20. Book a free demo. No credit card required."
        />
        <meta
          property="og:title"
          content="Getgeek's recruitment automation software gives your recruiters 6 AI agents - so a 2-person team does the work of 20. Book a free demo. No credit card required."
        />
        <meta
          property="og:description"
          content="Getgeek's recruitment automation software gives your recruiters 6 AI agents - so a 2-person team does the work of 20. Book a free demo. No credit card required."
        />
       
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta
          property="og:image:alt"
          content="Getgeek's recruitment automation software gives your recruiters 6 AI agents - so a 2-person team does the work of 20. Book a free demo. No credit card required."
        />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:title"
          content="Getgeek's recruitment automation software gives your recruiters 6 AI agents - so a 2-person team does the work of 20. Book a free demo. No credit card required."
        />
        <meta
          name="twitter:description"
          content="Getgeek's recruitment automation software gives your recruiters 6 AI agents - so a 2-person team does the work of 20. Book a free demo. No credit card required."
        />
        <meta
          name="twitter:url"
          content="https://getgeek.ai/ai-agents"
        />
        <link rel="canonical" href="https://getgeek.ai/ai-agents" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Head>
      <AdsPageNavbar />
      <HeroMainSection />

      <ScrollReveal delay={0.1} duration={1.0}>
        <HowItWorks />
      </ScrollReveal>

      <ScrollReveal delay={0.1} duration={1.0}>
        <div id="time-breakdown-section">
          <TimeBreakdownSection />
        </div>
      </ScrollReveal>
      <ScrollReveal delay={0.1} duration={1.0}>
        <AIAgentsSectionAds />
      </ScrollReveal>

      <ScrollReveal delay={0.1} duration={1.0}>
        <NumbersStats />
      </ScrollReveal>

      <ScrollReveal delay={0.2} duration={1.1}>
        <HiringWallSection />
      </ScrollReveal>

      <ScrollReveal delay={0.2} duration={1.1}>
        <RecruitmentTeam />
      </ScrollReveal>

      <ScrollReveal delay={0.1} duration={1.0}>
        <ObjectionsSection />
      </ScrollReveal>

      <ScrollReveal delay={0.2} duration={1.0}>
        <BookDemoSection />
      </ScrollReveal>

      <ScrollReveal delay={0.1} duration={1.0}>
        <CtaBanner />
      </ScrollReveal>

      <AdsFooter />
    </div>
  );
};

export default page;
